<template>
  <section v-if="features" class="section">
    <div class="features" :class="{ '--even': even }">
      <div
        v-for="(feature, index) in features"
        :key="`feature__${feature.title}__${index}`"
        class="feature"
        data-aos="fade-up"
      >
        <img
          v-if="feature.icon && feature.icon.mediaItemUrl"
          class="icon"
          v-lazy-load :data-src="feature.icon.mediaItemUrl"
          alt=""
          role="presentation"
        />

        <p class="title">
          {{ feature.title }}
        </p>
        <p class="content">
          {{ feature.content }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    features: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    even() {
      return !(this.features.length % 2)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/common/sections/AppFeaturesGridSection';
</style>
